import{g as e}from"./getThemeProps-7690ddf6.js";import{u as m}from"./useTheme-d06521c6.js";function r({props:r,name:t,defaultTheme:o,themeId:s}){let p=m(o);s&&(p=p[s]||p);return e({theme:p,name:t,props:r})}export{r as u};
